import { render, staticRenderFns } from "./ProductItem.vue?vue&type=template&id=fe399dba&scoped=true&"
import script from "./ProductItem.vue?vue&type=script&lang=js&"
export * from "./ProductItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductItem.vue?vue&type=style&index=0&id=fe399dba&lang=postcss&scoped=true&"
import style1 from "./ProductItem.vue?vue&type=style&index=1&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe399dba",
  null
  
)

export default component.exports